import { render, staticRenderFns } from "./compere-config.vue?vue&type=template&id=07200403"
import script from "./compere-config.vue?vue&type=script&lang=js"
export * from "./compere-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports